import type { FC } from 'react';
import { useTranslation } from 'react-i18next';
import WidgetBox, { Props as WidgetBoxProps } from '@wix/da-gruser-shared/pkg/components/WidgetBox';

import { GROUP_ACTIVE_MEMBERS_IDS_STREAM } from '../../../streams';
import UserStream from '../../_partials/UserStream';

interface Props {
  moduleId: number;
  widgetBoxProps?: WidgetBoxProps;
}

const ActiveMembersBox: FC<Props> = ({ moduleId, widgetBoxProps }) => {
  const { t } = useTranslation();
  return (
    <WidgetBox header={t(`widgets.active_members.header`)} moduleId={moduleId} {...widgetBoxProps}>
      <UserStream streamId={GROUP_ACTIVE_MEMBERS_IDS_STREAM} />
    </WidgetBox>
  );
};
ActiveMembersBox.displayName = 'ActiveMembersBox';

export default ActiveMembersBox;
